import { useEffect, useState } from "react";
import AddProductContainer from "./AddProductContainer";
import SeeProducts from "./SeeProducts";
import AddManufacturingCostContainer from "./AddManufacturingCostContainer";
import "./AdminContainer.scss";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../Icon";
import HighlightedContainer from "./highlightedContainer";
import classNames from "classnames";
import AdminCategoryContainer from "./AdminCategoryContainer";

const AdminContainer = () => {
  const [action, setAction] = useState<string>();
  const path = useLocation();

  const pathVerification = {
    edit: path.pathname.includes("edit"),
    add: path.pathname.includes("add"),
    see: path.pathname.includes("see"),
    category: path.pathname.includes("category"),
    manufacturing: path.pathname.includes("manufacturing"),
    highlightedSearches: path.pathname.includes("highlightedSearches"),
  };

  useEffect(() => {
    pathVerification.edit && setAction("edit");
    pathVerification.add && setAction("add");
    pathVerification.see && setAction("see");
    pathVerification.category && setAction("category");
    pathVerification.manufacturing && setAction("manufacturing");
    pathVerification.highlightedSearches && setAction("highlightedSearches");
    window.scrollTo(0, 0);
  }, [, path.pathname]);

  const adminSelectOptions = [
    {
      route: "/admin/see",
      classNameCondition: pathVerification.see || action == "see",
      text: "Productos",
      icon: "ProductsIcon",
      onClick: () => setAction("see"),
    },
    {
      route: "/admin/highlightedSearches",
      classNameCondition:
        pathVerification.highlightedSearches || action == "highlightedSearches",
      text: "Destacados",
      icon: "HighlightedIcon",
      onClick: () => setAction("highlightedSearches"),
    },
    {
      route: "/admin/manufacturing",
      classNameCondition:
        pathVerification.manufacturing || action == "manufacturing",
      text: "Hechuras",
      icon: "ManufacturingIcon",
      onClick: () => setAction("manufacturing"),
    },
    {
      route: "/admin/category",
      classNameCondition: pathVerification.category || action == "category",
      text: "Categorías",
      icon: "ManufacturingIcon",
      onClick: () => setAction("category"),
    },
  ];

  return (
    <>
      <div className="adminContainer">
        <div className="fixed">
          <div className="adminSelect">
            {adminSelectOptions.map((option, index) => (
              <Link
                key={index}
                to={option.route}
                className={
                  option.classNameCondition
                    ? "button__navigation button__navigation--selected"
                    : "button__navigation"
                }
                onClick={option.onClick}
              >
                <Icon
                  iconName={option.icon}
                  className={classNames("adminSelect__icon-navigation", {
                    "adminSelect__icon-navigation--selected":
                      option.classNameCondition,
                  })}
                />
                {option.text}
              </Link>
            ))}
          </div>
        </div>

        <div className="adminOptions">
          <div className="adminOptions__container">
            {action && (action == "add" || action == "edit") ? (
              <AddProductContainer />
            ) : action == "see" ? (
              <SeeProducts />
            ) : action == "manufacturing" ? (
              <AddManufacturingCostContainer />
            ) : action == "highlightedSearches" ? (
              <HighlightedContainer />
            ) : action == "category" ? (
              <AdminCategoryContainer />
            ) : (
              <SeeProducts />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminContainer;
